<template>
  <div v-if="showBlock" class="tag-cloud-widget">
    <BlockTitle />
    <div class="tag-cloud-widget__content">
      <div v-for="tag in tagCloud" :key="tag.key" class="tag-cloud-widget__item">
        <link-handler :href="tag.value" @click.native.prevent="logClick(tag.value)">{{ tag.key }}</link-handler>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

import BlockTitle from './fragments/BlockTitle.vue';
import GetPageBlockService from '../core/services/pageBlock.service';
import LinkHandler from '@core/components/helpers/LinkHandler.vue';

type TagCloudTag = {
  key: string;
  value: string;
};

interface WidgetOptions {
  locale: string;
}

interface Props {
  options: WidgetOptions;
}

interface Data {
  showBlock: boolean;
  tagCloud: TagCloudTag[];
}

interface Methods {
  getTagCloud: () => void;
  logClick: (url: string) => void;
}

export default Vue.extend<Data, Methods, unknown, Props>({
  components: {
    BlockTitle,
    LinkHandler,
  },
  props: {
    options: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      showBlock: false,
      tagCloud: [],
    };
  },
  methods: {
    async getTagCloud() {
      const getPageBlockService = new GetPageBlockService();
      const variables = { id: 'aec03a9c-84f4-47d7-88ce-df35e5e78e34' };
      const response = await getPageBlockService.fetch(variables);

      if (response?.blocks?.length) {
        const block = response.blocks[0];
        this.tagCloud = block.attributes.find((a) => a.key === 'blockData' && a.value.config)?.value?.config;
      }
    },
    logClick(url) {
      const params = { section: `Aktualu`, url };

      window.cX.sendEvent('section_click', params, { origin: 'lth-delfi', persistedQueryId: '60134f11dac530e2cd5c308a42f829d82289a3b8' });

      location.href = url;
    },
  },
  async mounted() {
    await this.$nextTick();
    await this.getTagCloud();

    if (this.tagCloud.length) {
      this.showBlock = true;
    }

    // Track block impressions
    this.$nextTick(() => {
      const elemsToObserve = document.querySelectorAll('.tag-cloud-widget');
      const sectionsObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            const params = { section: `Aktualu` };

            window.cX.sendEvent('section_visible', params, { origin: 'lth-delfi', persistedQueryId: '60134f11dac530e2cd5c308a42f829d82289a3b8' });

            sectionsObserver.unobserve(entry.target);
          }
        });
      }, {});

      elemsToObserve.forEach((elemToObserve) => {
        sectionsObserver.observe(elemToObserve);
      });
    });
  },
});
</script>

<style lang="scss" scoped>
.tag-cloud-widget {
  &__content {
    display: flex;
    flex-wrap: wrap;
    gap: 20px 30px;
    margin-top: 16px;
    padding: 30px;
    font-size: 14px;
    font-weight: 500;
    background-color: #edf2f4;
    border-radius: 10px;
  }

  &__item {
    color: get-color('color-1');

    &:hover {
      color: get-color('color-1');
    }
  }
}
</style>
